import { Component, OnInit } from '@angular/core';
import { EmployeeService } from '../services/employee.service';

@Component({
  selector: 'app-number-generator',
  templateUrl: './number-generator.component.html',
  styleUrls: ['./number-generator.component.css']
})
export class NumberGeneratorComponent implements OnInit {

  generatedNumber: string = '';
  prefix: string = 'C';
  copySuccess: boolean = false;
  numberLength: number = 5;
  isGenerating: boolean = false;

  constructor(private employeeService: EmployeeService) { }

  ngOnInit(): void {
  }

  generateNumber(): void {
    // if(this.numberLength < 5 || this.numberLength > 10) {
    //   this.numberLength = 5
    // }
    this.isGenerating = true;
    this.employeeService.generateClientAgreementNumber(this.prefix).subscribe({
      next: (response) => {
        this.generatedNumber = response.message;
        this.isGenerating = false;
      },
      error: (error) => {
        console.error('Error generating number:', error);
        this.isGenerating = false;
      }
    });
  }

  setPrefix(prefix: string): void {
    this.prefix = prefix;
    this.generatedNumber = '';
    this.copySuccess = false;
  }

  copyToClipboard(): void {
    if (this.generatedNumber) {
      navigator.clipboard.writeText(this.generatedNumber).then(() => {
        this.copySuccess = true;
        setTimeout(() => {
          this.copySuccess = false;
        }, 2000);
      }).catch(err => {
        console.error('Failed to copy: ', err);
      });
    }
  }


}
